/* eslint-disable */

import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc, updateDoc, collection, query, orderBy, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

import { db } from "../firebase";

// Inject DM Sans + DM Mono
if (typeof document !== "undefined" && !document.getElementById("dm-fonts")) {
  const link = document.createElement("link");
  link.id = "dm-fonts";
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap";
  document.head.appendChild(link);
}

const ITEMS_PER_PAGE = 5;
const API_BASE_URL = process.env.NODE_ENV === "development"
  ? "http://127.0.0.1:5002/offers-5e23d/us-central1"
  : "https://us-central1-offers-5e23d.cloudfunctions.net";

const card = { background: "#fff", border: "1px solid #e4e7f0", borderRadius: 14, overflow: "hidden", fontFamily: "'DM Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif" };
const divider = { height: 1, background: "#e4e7f0" };

function Alert({ type = "info", icon, title, msg, onDismiss }) {
  const c = { success: { bg: "#f0fdf4", color: "#15803d", bc: "#bbf7d0" }, warning: { bg: "#fffbeb", color: "#b45309", bc: "#fde68a" }, danger: { bg: "#fef2f2", color: "#b91c1c", bc: "#fecaca" }, info: { bg: "#eff6ff", color: "#1d4ed8", bc: "#bfdbfe" } }[type];
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 12px", borderRadius: 10, fontSize: 12, lineHeight: 1.5, border: `1px solid ${c.bc}`, background: c.bg, color: c.color, marginBottom: 10, position: "relative", paddingRight: onDismiss ? 32 : 12 }}>
      {icon && <span style={{ fontSize: 14, flexShrink: 0 }}>{icon}</span>}
      <div>{title && <div style={{ fontWeight: 600, marginBottom: 2 }}>{title}</div>}<div style={{ opacity: 0.9 }}>{msg}</div></div>
      {onDismiss && <button onClick={onDismiss} style={{ position: "absolute", top: 8, right: 8, background: "none", border: "none", cursor: "pointer", color: "inherit", opacity: 0.6, fontSize: 13 }}>✕</button>}
    </div>
  );
}

function EarningsPanel({ user, message, setMessage, onManageAccount, onSetupPayments, onInitiatePayout, onDismissPayout, onForceNewAccount }) {
  const isPending = user.userStatus === "pending";
  const isSetup = user.paymentSetupStatus === "setup";
  const showFixButton = message && (message.includes("Error") || message.includes("capability") || message.includes("transfers") || message.includes("incomplete"));
  const fmt = (n) => (n != null ? "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—");

  return (
    <div style={card}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>💳</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em", color: "#111827" }}>Earnings Dashboard</div>
            <div style={{ fontSize: 12, color: "#9ca3b4", marginTop: 1 }}>Payouts and payment setup</div>
          </div>
        </div>
        <Link to="/payout-history" style={{ padding: "6px 12px", borderRadius: 6, fontFamily: "inherit", fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1px solid #e4e7f0", background: "#fff", color: "#4b5568", textDecoration: "none" }}>
          View Payment History
        </Link>
      </div>
      <div style={divider} />
      <div style={{ padding: "16px 20px" }}>
        <div style={{ background: "#fff", border: "1px solid #dde4ff", borderRadius: 10, padding: "18px 28px", marginBottom: 14, textAlign: "center", overflow: "visible" }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#6366f1", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 4 }}>Total Earnings</div>
          <div style={{ marginBottom: 4, overflow: "visible" }}>
            <span style={{ fontSize: 42, fontWeight: 700, letterSpacing: "-.04em", fontFamily: "'DM Mono','Courier New',monospace", background: "linear-gradient(135deg,#2563eb,#9333ea)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", lineHeight: 1, display: "inline-block", padding: "0 8px", overflow: "visible" }}>{fmt(user.credit)}</span>
          </div>
          <div style={{ fontSize: 11, color: "#9ca3b4" }}>Available credit balance</div>
        </div>

        {isPending && <Alert type="warning" icon="⏳" title="Account Under Review" msg={user.pendingMessage || "Under review. Payouts unavailable until approved."} />}
        {!isSetup && user.paymentSetupStatus === "pending" && <Alert type="info" icon="ℹ️" title="Payment setup required" msg="Set up your Stripe account to receive payments." />}
        {isSetup && <Alert type="success" icon="✅" title="Payment setup complete" msg="You're all set! Initiate a payout when ready." />}
        {message && <Alert type={/success|complete|already set up/i.test(message) ? "success" : /Redirecting|Setting up|Please complete|Creating/i.test(message) ? "info" : "danger"} msg={message} onDismiss={() => setMessage(null)} />}
        {user.lastPayoutStatus === "pending" && user.lastPayoutAmount && !user.dismissedPayoutNotification && (
          <Alert type="info" icon="⏳" title="Payout Pending" msg={`Your $${Number(user.lastPayoutAmount).toFixed(2)} payout is processing. Arrives in 2–7 business days.`} onDismiss={onDismissPayout} />
        )}

        {showFixButton && (
          <div style={{ marginBottom: 10 }}>
            <button onClick={onForceNewAccount} style={{ padding: "9px 14px", borderRadius: 6, fontFamily: "inherit", fontSize: 13, fontWeight: 600, cursor: "pointer", border: "none", background: "linear-gradient(135deg,#ea580c,#dc2626)", color: "#fff", width: "100%" }}>
              🔧 Fix Payment Setup - Create New Account
            </button>
            <div style={{ fontSize: 11, color: "#9ca3b4", marginTop: 4 }}>Removes incomplete Stripe account and creates a fresh one.</div>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 4 }}>
          <button onClick={isSetup ? onManageAccount : onSetupPayments} style={{ padding: "9px 14px", borderRadius: 6, fontFamily: "inherit", fontSize: 13, fontWeight: 600, cursor: "pointer", border: "1px solid #e4e7f0", background: "#fff", color: "#4b5568" }}>
            {isSetup ? "Manage Account" : "Set Up Payments"}
          </button>
          <button disabled={isPending || user.credit <= 0} onClick={onInitiatePayout} style={{ padding: "9px 14px", borderRadius: 6, fontFamily: "inherit", fontSize: 13, fontWeight: 600, cursor: "pointer", border: "none", background: "linear-gradient(135deg,#4361ee,#7c3aed)", color: "#fff", opacity: (isPending || user.credit <= 0) ? 0.4 : 1 }}>
            Initiate Payout
          </button>
        </div>
        {isPending && <div style={{ fontSize: 11, color: "#9ca3b4", marginTop: 6 }}>Account under review — payouts unavailable until approved.</div>}
        {!isPending && user.credit <= 0 && <div style={{ fontSize: 11, color: "#9ca3b4", marginTop: 6 }}>Insufficient credit to initiate payout.</div>}
      </div>
    </div>
  );
}

function DetailsPanel({ userDetails, isEditing, onEditToggle, onSaveDetails, onInputChange }) {
  const gridFields = [
    { key: "gpa", label: "GPA" },
    { key: "testScore", label: "Test Score" },
    { key: "sai", label: "Student Aid Index" },
    { key: "state", label: "State" },
  ];
  const inp = { width: "100%", background: "#f9fafb", border: "1px solid #c9cfe0", borderRadius: 6, padding: "7px 10px", fontFamily: "inherit", fontSize: 13, color: "#111827", outline: "none", boxSizing: "border-box" };
  return (
    <div style={card}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>🎓</div>
          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em", color: "#111827" }}>Your Details</div>
        </div>
        <button onClick={isEditing ? onSaveDetails : onEditToggle} style={{ padding: "6px 12px", borderRadius: 6, fontFamily: "inherit", fontSize: 12, fontWeight: 600, cursor: "pointer", border: isEditing ? "1px solid rgba(22,163,74,.3)" : "1px solid #e4e7f0", background: isEditing ? "rgba(22,163,74,.1)" : "none", color: isEditing ? "#16a34a" : "#9ca3b4" }}>
          {isEditing ? "✓ Save Changes" : "✏️ Edit"}
        </button>
      </div>
      <div style={divider} />
      <div style={{ padding: "16px 20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, background: "#e4e7f0", border: "1px solid #e4e7f0", borderRadius: 10, overflow: "hidden" }}>
          {gridFields.map((f) => (
            <div key={f.key} style={{ background: "#fff", padding: "11px 14px" }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#9ca3b4", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 3 }}>{f.label}</div>
              {isEditing ? (
                <input style={inp} name={f.key} value={userDetails[f.key] || ""} onChange={onInputChange} />
              ) : (
                <div style={{ fontSize: 13, fontWeight: 500, color: userDetails[f.key] ? "#111827" : "#9ca3b4", fontStyle: userDetails[f.key] ? "normal" : "italic" }}>{userDetails[f.key] || "Not specified"}</div>
              )}
            </div>
          ))}
          <div style={{ background: "#fff", padding: "11px 14px", gridColumn: "1/-1" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#9ca3b4", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 3 }}>Extracurricular Activities</div>
            {isEditing ? (
              <textarea style={{ ...inp, resize: "vertical", minHeight: 68, lineHeight: 1.5 }} name="activities" value={userDetails.activities || ""} onChange={onInputChange} />
            ) : (
              <div style={{ fontSize: 13, fontWeight: 500, color: userDetails.activities ? "#111827" : "#9ca3b4", fontStyle: userDetails.activities ? "normal" : "italic", lineHeight: 1.5 }}>{userDetails.activities || "No activities specified"}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function PayoutHistoryPanel({ history }) {
  const [open, setOpen] = useState(false);
  const fmt = (n) => (n != null ? "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—");
  return (
    <div style={card}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>📋</div>
          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em", color: "#111827" }}>Payout History</div>
        </div>
        <button onClick={() => setOpen((o) => !o)} style={{ padding: "6px 12px", borderRadius: 6, fontFamily: "inherit", fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1px solid #e4e7f0", background: "none", color: "#9ca3b4" }}>{open ? "Hide" : "View History"}</button>
      </div>
      {open && (
        <>
          <div style={divider} />
          <div style={{ padding: "12px 20px 16px" }}>
            {history.map((p, i) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 0", borderBottom: i < history.length - 1 ? "1px solid #e4e7f0" : "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: p.status === "paid" ? "#16a34a" : "#9ca3b4", flexShrink: 0 }} />
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>{fmt(p.amount)}</span>
                      <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 99, background: p.status === "paid" ? "#f0fdf4" : "#f3f4f6", color: p.status === "paid" ? "#16a34a" : "#9ca3b4", border: `1px solid ${p.status === "paid" ? "#bbf7d0" : "#e4e7f0"}` }}>{p.status === "paid" ? "Completed" : "Processing"}</span>
                    </div>
                    <div style={{ fontSize: 11, color: "#9ca3b4", marginTop: 1 }}>Initiated {p.created ? new Date(p.created).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }) : "—"}</div>
                    <div style={{ fontSize: 10, fontFamily: "'DM Mono',monospace", color: "#9ca3b4" }}>ID: {p.id}</div>
                  </div>
                </div>
              </div>
            ))}
            <div style={{ fontSize: 11, color: "#9ca3b4", textAlign: "center", marginTop: 12 }}>Questions? <a href="mailto:pocketly.ai@gmail.com" style={{ color: "#4361ee" }}>pocketly.ai@gmail.com</a></div>
          </div>
        </>
      )}
    </div>
  );
}

function getSAIForOffer(offer) {
  if (offer.efc_or_sai) return offer.efc_or_sai;
  if (offer.efc_brackets) {
    for (const [bracketKey, value] of Object.entries(offer.efc_brackets)) {
      if (value === true) {
        if (bracketKey.startsWith("above_")) {
          const min = parseInt(bracketKey.replace(/[^0-9]/g, ""), 10);
          return min + 10000;
        } else if (bracketKey.startsWith("under_")) {
          const max = parseInt(bracketKey.replace(/[^0-9]/g, ""), 10);
          return max / 2;
        } else if (bracketKey.includes("_")) {
          const [minStr, maxStr] = bracketKey.split("_");
          const min = parseInt(minStr, 10);
          const max = parseInt(maxStr, 10);
          return (min + max) / 2;
        }
      }
    }
  }
  return null;
}

function formatNumber(value, noComma = false) {
  if (!value) return "0";
  const num = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(num)) return "0";
  return noComma ? num.toFixed(0) : num.toLocaleString("en-US", { maximumFractionDigits: 0 });
}

function capitalizeFirstLetter(name) {
  const exceptions = ["of", "and", "for", "the", "at", "in", "on"];
  return name
    .toLowerCase()
    .split(" ")
    .map((word, index) => (index === 0 || !exceptions.includes(word) ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ");
}

function OffersPanel({ offers, currentPage, setCurrentPage, onRefresh, onRemoveOffer, loading }) {
  const total = Math.ceil(offers.length / ITEMS_PER_PAGE);
  const paged = offers.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  const fmt = (n) => (n != null ? "$" + Number(n).toLocaleString() : "—");
  const pill = (st) => (st === "approved" ? { bg: "rgba(22,163,74,.1)", color: "#16a34a" } : st === "pending" ? { bg: "rgba(217,119,6,.1)", color: "#d97706" } : { bg: "rgba(220,38,38,.08)", color: "#dc2626" });
  const th = { padding: "9px 12px", fontSize: 10, fontWeight: 700, color: "#9ca3b4", letterSpacing: ".07em", textTransform: "uppercase", textAlign: "left", whiteSpace: "nowrap", borderBottom: "1px solid #e4e7f0" };
  const td = { padding: "11px 12px", fontSize: 13, color: "#4b5568", borderBottom: "1px solid #e4e7f0", whiteSpace: "nowrap" };

  return (
    <div style={{ ...card, gridColumn: "1/-1" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#f0f2f8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>📄</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em", color: "#111827" }}>My Offer Letters</div>
            <div style={{ fontSize: 12, color: "#9ca3b4", marginTop: 1 }}>Track uploaded offer letters and their performance</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 11, color: "#9ca3b4", fontWeight: 600 }}>{offers.length} offer{offers.length !== 1 ? "s" : ""}</span>
          <button disabled={loading} onClick={onRefresh} style={{ padding: "6px 12px", borderRadius: 6, fontFamily: "inherit", fontSize: 12, fontWeight: 600, cursor: "pointer", border: "1px solid #e4e7f0", background: "none", color: "#9ca3b4" }}>{loading ? "…" : "↻ Refresh"}</button>
        </div>
      </div>
      <div style={divider} />
      {offers.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 24px" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📂</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#111827", marginBottom: 6 }}>No offer letters yet</div>
          <div style={{ fontSize: 13, color: "#9ca3b4", marginBottom: 16 }}>Upload your first offer letter to start earning!</div>
          <Link to="/offerLetterUpload">
            <button style={{ padding: "9px 20px", borderRadius: 6, fontFamily: "inherit", fontSize: 13, fontWeight: 600, border: "none", background: "linear-gradient(135deg,#4361ee,#7c3aed)", color: "#fff", cursor: "pointer" }}>Upload Offer Letter</button>
          </Link>
        </div>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 780 }}>
              <thead style={{ background: "#f0f2f8" }}>
                <tr>{["Status", "School", "Cost", "Financial Aid", "Merit Aid", "Other Aid", "Test", "GPA", "SAI", "State", "Admission"].map((h) => <th key={h} style={th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {paged.map((o, ri) => {
                  const p = pill(o.status);
                  const offerIndex = (currentPage - 1) * ITEMS_PER_PAGE + ri;
                  const saiVal = getSAIForOffer(o);
                  const testStr = o.composite_sat ? `SAT: ${formatNumber(o.composite_sat, true)}` : o.composite_act ? `ACT: ${formatNumber(o.composite_act, true)}` : "N/A";
                  return (
                    <tr key={o.offerId || ri} style={{ background: ri % 2 === 0 ? "#fff" : "#f9fafb" }}>
                      <td style={td}>
                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 99, background: p.bg, color: p.color }}>
                            <span style={{ width: 5, height: 5, borderRadius: "50%", background: "currentColor", display: "inline-block" }} />{o.status}
                          </span>
                          {o.status === "rejected" && (
                            <>
                              <Link to="/rejection-reasons" style={{ fontSize: 11, color: "#4361ee", textDecoration: "none" }}>Why?</Link>
                              <button onClick={() => onRemoveOffer(offerIndex)} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3b4", fontSize: 11, padding: "1px 4px", borderRadius: 4 }}>✕</button>
                            </>
                          )}
                        </div>
                      </td>
                      <td style={{ ...td, fontWeight: 500, color: "#111827", textTransform: "capitalize" }}>{capitalizeFirstLetter(o.school_name || "Unknown")}</td>
                      <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: 12 }}>{fmt(o.cost_of_attendance)}</td>
                      <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: 12 }}>{fmt((o.financial_aid || 0) + (o.need_based_grant_aid || 0))}</td>
                      <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: 12 }}>{fmt(o.merit_aid)}</td>
                      <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: 12 }}>{fmt(o.other_aid || o.other_private_scholarships)}</td>
                      <td style={td}>{testStr}</td>
                      <td style={td}>{o.gpa || "N/A"}</td>
                      <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: 12 }}>{saiVal != null ? formatNumber(saiVal) : "N/A"}</td>
                      <td style={td}>{o.state_of_residence || "N/A"}</td>
                      <td style={td}>{o.admission_type || "Regular Admission"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {total > 1 && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", background: "#f0f2f8", borderTop: "1px solid #e4e7f0" }}>
              <span style={{ fontSize: 12, color: "#9ca3b4" }}>Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–{Math.min(currentPage * ITEMS_PER_PAGE, offers.length)} of {offers.length}</span>
              <div style={{ display: "flex", gap: 4 }}>
                <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} style={{ minWidth: 30, height: 30, borderRadius: 6, border: "1px solid #e4e7f0", background: "#fff", fontSize: 12, fontWeight: 600, color: "#4b5568", cursor: "pointer", opacity: currentPage === 1 ? 0.3 : 1 }}>←</button>
                {Array.from({ length: total }, (_, i) => (
                  <button key={i + 1} onClick={() => setCurrentPage(i + 1)} style={{ minWidth: 30, height: 30, borderRadius: 6, border: "1px solid #e4e7f0", background: currentPage === i + 1 ? "#4361ee" : "#fff", color: currentPage === i + 1 ? "#fff" : "#4b5568", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{i + 1}</button>
                ))}
                <button disabled={currentPage === total} onClick={() => setCurrentPage((p) => Math.min(total, p + 1))} style={{ minWidth: 30, height: 30, borderRadius: 6, border: "1px solid #e4e7f0", background: "#fff", fontSize: 12, fontWeight: 600, color: "#4b5568", cursor: "pointer", opacity: currentPage === total ? 0.3 : 1 }}>→</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default function ProfilePage() {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [credit, setCredit] = useState(0);
  const [userOffers, setUserOffers] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentSetupStatus, setPaymentSetupStatus] = useState("unknown");
  const [payoutHistory, setPayoutHistory] = useState([]);
  const [lastPayoutStatus, setLastPayoutStatus] = useState(null);
  const [lastPayoutAmount, setLastPayoutAmount] = useState(null);
  const [lastPayoutDate, setLastPayoutDate] = useState(null);
  const [userDetails, setUserDetails] = useState({ gpa: "", testScore: "", sai: "", state: "", activities: "" });
  const [userStatus, setUserStatus] = useState(null);
  const [pendingMessage, setPendingMessage] = useState(null);
  const [dismissedPayoutNotification, setDismissedPayoutNotification] = useState(false);
  const [offersRefreshing, setOffersRefreshing] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    if (lastPayoutStatus === "pending" && lastPayoutAmount && lastPayoutDate) {
      const key = `payout_dismissed_${lastPayoutAmount}_${lastPayoutDate}`;
      setDismissedPayoutNotification(!!localStorage.getItem(key));
    }
  }, [lastPayoutStatus, lastPayoutAmount, lastPayoutDate]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        await fetchUserData(user.uid);
        const urlParams = new URLSearchParams(window.location.search);
        const setupStatus = urlParams.get("setup");
        if (setupStatus === "complete") {
          setMessage("Stripe account setup completed successfully! You can now receive payouts.");
          setPaymentSetupStatus("setup");
          window.history.replaceState({}, document.title, window.location.pathname);
        } else if (setupStatus === "refresh") {
          setMessage("Please complete your Stripe account setup to receive payouts.");
          window.history.replaceState({}, document.title, window.location.pathname);
        }
        const manageStatus = urlParams.get("manage");
        if (manageStatus === "complete") {
          setMessage("Account details updated successfully!");
          window.history.replaceState({}, document.title, window.location.pathname);
        } else if (manageStatus === "refresh") {
          setMessage("Please complete updating your account details.");
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const fetchUserData = async (uid) => {
    try {
      const userRef = doc(db, "users", uid);
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        const userData = userDoc.data();
        let offersArray = [];
        if (userData.offers) {
          offersArray = Array.isArray(userData.offers) ? userData.offers : Object.values(userData.offers);
          if (!Array.isArray(userData.offers)) {
            try {
              await updateDoc(userRef, { offers: offersArray });
            } catch (e) {
              console.error("Failed to fix offers in Firestore:", e);
            }
          }
        }
        const schoolIds = [...new Set(offersArray.map((o) => o.schoolId).filter(Boolean))];
        const statusByOfferId = {};
        for (const schoolId of schoolIds) {
          try {
            const schoolRef = doc(db, "offerLetters", schoolId);
            const schoolSnap = await getDoc(schoolRef);
            if (schoolSnap.exists()) {
              const schoolOffers = schoolSnap.data()?.offers;
              const arr = Array.isArray(schoolOffers) ? schoolOffers : schoolOffers ? Object.values(schoolOffers) : [];
              arr.forEach((o) => {
                if (o.offerId && (o.status === "approved" || o.status === "rejected")) statusByOfferId[o.offerId] = o.status;
              });
            }
          } catch (e) {
            console.warn("[Profile] Failed to fetch offerLetters for school", schoolId, e);
          }
        }
        const offersWithStatus = offersArray.map((o) => ({ ...o, status: statusByOfferId[o.offerId] ?? o.status }));
        setCredit(userData.credit || 0);
        setUserOffers(offersWithStatus);
        setUserDetails({ gpa: userData.gpa || "", testScore: userData.testScore || "", sai: userData.sai || "", state: userData.state || "", activities: userData.activities || "" });
        setPaymentSetupStatus(userData.stripeAccountId ? "setup" : "pending");
        setLastPayoutStatus(userData.lastPayoutStatus || null);
        setLastPayoutAmount(userData.lastPayoutAmount || null);
        setLastPayoutDate(userData.lastPayoutDate || null);
        setUserStatus(userData.userStatus || null);
        setPendingMessage(userData.pendingMessage || null);
        await fetchPayoutHistory(uid);
      }
    } catch (error) {
      console.error("[Profile] Error fetching user data:", error);
    }
  };

  const fetchPayoutHistory = async (uid) => {
    try {
      const payoutHistoryRef = collection(db, "users", uid, "payoutHistory");
      const q = query(payoutHistoryRef, orderBy("created", "desc"));
      const querySnapshot = await getDocs(q);
      const history = [];
      querySnapshot.forEach((docSnap) => history.push({ id: docSnap.id, ...docSnap.data() }));
      setPayoutHistory(history);
    } catch (error) {
      console.error("Error fetching payout history:", error);
    }
  };

  const handleEditToggle = () => setIsEditing((prev) => !prev);
  const handleInputChange = (e) => setUserDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSaveDetails = async () => {
    const user = getAuth().currentUser;
    if (!user) return;
    try {
      await updateDoc(doc(db, "users", user.uid), userDetails);
      setIsEditing(false);
      setMessage("Details updated successfully!");
    } catch (error) {
      console.error("Error updating user details:", error);
      setMessage("Failed to update details.");
    }
  };

  const handleRemoveOffer = async (offerIndex) => {
    const user = getAuth().currentUser;
    if (!user) {
      alert("You must be logged in to remove offers.");
      return;
    }
    if (!window.confirm("Are you sure you want to remove this rejected offer? This action cannot be undone.")) return;
    try {
      const updatedOffers = userOffers.filter((_, i) => i !== offerIndex);
      await updateDoc(doc(db, "users", user.uid), { offers: updatedOffers });
      setUserOffers(updatedOffers);
      const totalPages = Math.ceil(updatedOffers.length / ITEMS_PER_PAGE);
      if (currentPage > totalPages && totalPages > 0) setCurrentPage(totalPages);
      setMessage("Rejected offer removed successfully.");
    } catch (error) {
      console.error("Error removing offer:", error);
      setMessage("Failed to remove offer. Please try again.");
    }
  };

  const handleManageAccount = async () => {
    setMessage(null);
    const user = getAuth().currentUser;
    if (!user) {
      setMessage("User not authenticated. Please log in.");
      return;
    }
    setMessage("Redirecting to manage your account...");
    try {
      const res = await fetch(`${API_BASE_URL}/manageStripeAccount`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ userId: user.uid }) });
      const data = await res.json();
      if (data.success && data.accountLink) {
        setMessage("Redirecting to Stripe account management...");
        setTimeout(() => (window.location.href = data.accountLink), 500);
      } else {
        setMessage(`Error: ${data.error || "Failed to create management link"}`);
      }
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    }
  };

  const handleSetupPayments = async () => {
    setMessage(null);
    const user = getAuth().currentUser;
    if (!user) {
      setMessage("User not authenticated. Please log in.");
      return;
    }
    setMessage("Setting up your payment account...");
    try {
      const res = await fetch(`${API_BASE_URL}/setupStripeAccount`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ userId: user.uid }) });
      const data = await res.json();
      if (data.success) {
        setMessage(`Your Stripe account is already set up for payouts! Account ID: ${data.accountId}`);
        setPaymentSetupStatus("setup");
      } else if (data.onboardingRequired && data.accountLink && data.accountLink.startsWith("https://")) {
        setMessage("Redirecting to Stripe onboarding...");
        setTimeout(() => (window.location.href = data.accountLink), 500);
      } else {
        setMessage(`Error setting up payment: ${data.message || data.error || "Unknown error"}`);
      }
    } catch (error) {
      setMessage(`An error occurred while setting up your payment account: ${error.message || "Unknown error"}`);
    }
  };

  const handleForceNewAccount = async () => {
    setMessage("Clearing existing account and creating a fresh one...");
    const user = getAuth().currentUser;
    if (!user) {
      setMessage("User not authenticated. Please log in.");
      return;
    }
    try {
      const { deleteField } = await import("firebase/firestore");
      await updateDoc(doc(db, "users", user.uid), { stripeAccountId: deleteField(), stripeCustomerId: deleteField() });
      setPaymentSetupStatus("pending");
      await new Promise((r) => setTimeout(r, 1000));
      const res = await fetch(`${API_BASE_URL}/setupStripeAccount`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ userId: user.uid }) });
      const data = await res.json();
      if (data.onboardingRequired && data.accountLink) {
        setMessage("Fresh account created! Redirecting to Stripe onboarding...");
        window.location.href = data.accountLink;
      } else if (data.success) {
        setMessage("Payment account setup complete!");
        setPaymentSetupStatus("setup");
      } else {
        setMessage(`Failed to create fresh account: ${data.message || data.error || "Unknown error"}`);
      }
    } catch (error) {
      setMessage(`Failed to create new account: ${error.message}`);
    }
  };

  const handleInitiatePayout = async () => {
    setMessage(null);
    if (userStatus === "pending") {
      setMessage("Your account is currently under review. Please wait for approval before initiating payouts.");
      return;
    }
    if (credit <= 0) {
      setMessage("Insufficient credit to initiate payout.");
      return;
    }
    const user = getAuth().currentUser;
    if (!user) {
      setMessage("User not authenticated. Please log in.");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/createPayout`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ amount: credit, userId: user.uid }) });
      const data = await res.json();
      if (data.success) {
        setMessage("Payout successfully initiated! Payment is pending to your account.");
        setLastPayoutStatus("pending");
        setLastPayoutAmount(credit);
        setLastPayoutDate(new Date().toISOString());
        setCredit(0);
        await fetchUserData(user.uid);
      } else if (data.onboardingRequired) {
        setMessage("Redirecting to Stripe onboarding...");
        setTimeout(() => (window.location.href = data.accountLink), 1000);
      } else {
        setMessage(`Payout failed: ${data.error}`);
      }
    } catch (error) {
      setMessage("An error occurred while initiating the payout.");
    }
  };

  const handleDismissPayoutNotification = () => {
    if (lastPayoutStatus === "pending" && lastPayoutAmount && lastPayoutDate) {
      localStorage.setItem(`payout_dismissed_${lastPayoutAmount}_${lastPayoutDate}`, "1");
    }
    setDismissedPayoutNotification(true);
  };

  const handleSignOut = async () => {
    try {
      await signOut(getAuth());
      window.location.href = "/";
    } catch (error) {
      console.error("Error signing out:", error);
      setMessage("Failed to sign out. Please try again.");
    }
  };

  const handleRefreshOffers = async () => {
    if (!currentUser || offersRefreshing) return;
    setOffersRefreshing(true);
    await fetchUserData(currentUser.uid);
    setOffersRefreshing(false);
  };

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif" }}>
        <p style={{ fontSize: 16, color: "#6b7280" }}>Loading...</p>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, fontFamily: "'DM Sans',sans-serif" }}>
        <p style={{ fontSize: 16, color: "#6b7280" }}>Please sign in to view your profile.</p>
        <Link to="/auth" style={{ padding: "10px 20px", background: "#4361ee", color: "#fff", borderRadius: 8, textDecoration: "none", fontWeight: 600 }}>Sign In</Link>
      </div>
    );
  }

  const userForEarnings = {
    credit,
    userStatus,
    paymentSetupStatus,
    pendingMessage,
    lastPayoutStatus,
    lastPayoutAmount,
    dismissedPayoutNotification,
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: "100vh", width: "100%", background: "#f4f6fb", fontFamily: "'DM Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif", fontSize: 16, color: "#111827", lineHeight: 1.5 }}>
      <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0, width: "100%", maxWidth: 1100 }}>
        <div style={{ height: 56, borderBottom: "1px solid #e4e7f0", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px", flexShrink: 0, position: "relative" }}>
          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em", textAlign: "center" }}>Your Profile</div>
          <div style={{ position: "absolute", right: 24, top: "50%", transform: "translateY(-50%)" }}>
            <button onClick={() => setSettingsOpen((o) => !o)} style={{ width: 34, height: 34, borderRadius: 6, border: "1px solid #e4e7f0", background: "#fff", cursor: "pointer", fontSize: 14, color: "#4b5568", display: "flex", alignItems: "center", justifyContent: "center" }}>⚙</button>
            {settingsOpen && (
              <div style={{ position: "absolute", top: "calc(100% + 6px)", right: 0, background: "#fff", border: "1px solid #c9cfe0", borderRadius: 10, minWidth: 170, overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,.12)", zIndex: 100 }}>
                <Link to="/billing-history" onClick={() => setSettingsOpen(false)} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", fontSize: 13, fontWeight: 500, color: "#4b5568", textDecoration: "none", borderBottom: "1px solid #e4e7f0" }}>🧾 Billing History</Link>
                <Link to="/payout-history" onClick={() => setSettingsOpen(false)} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", fontSize: 13, fontWeight: 500, color: "#4b5568", textDecoration: "none", borderBottom: "1px solid #e4e7f0" }}>💸 Payout History</Link>
                <button onClick={handleSignOut} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", fontSize: 13, fontWeight: 500, color: "#dc2626", border: "none", background: "none", cursor: "pointer", width: "100%", fontFamily: "inherit" }}>🚪 Sign Out</button>
              </div>
            )}
          </div>
        </div>

        <div style={{ padding: 24, flex: 1, overflow: "auto" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <EarningsPanel user={userForEarnings} message={message} setMessage={setMessage} onManageAccount={handleManageAccount} onSetupPayments={handleSetupPayments} onInitiatePayout={handleInitiatePayout} onDismissPayout={handleDismissPayoutNotification} onForceNewAccount={handleForceNewAccount} />
            <DetailsPanel userDetails={userDetails} isEditing={isEditing} onEditToggle={handleEditToggle} onSaveDetails={handleSaveDetails} onInputChange={handleInputChange} />
            {paymentSetupStatus === "setup" && payoutHistory.length > 0 && <PayoutHistoryPanel history={payoutHistory} />}
            <OffersPanel offers={userOffers} currentPage={currentPage} setCurrentPage={setCurrentPage} onRefresh={handleRefreshOffers} onRemoveOffer={handleRemoveOffer} loading={offersRefreshing} />
          </div>
        </div>
      </main>
    </div>
  );
}
